// extracted by mini-css-extract-plugin
export default {"ace-c-lea-logo":"text-management-screen---3ff947b7"};